import { Component, Input } from '@angular/core';
import {
  OrderHistoryGaTrackingService
} from '~app/modules/account/modules/orders-history/services/order-history-ga-tracking.service';
import { LinkTypeEnum } from '~shared/constants';

@Component({
  selector: 'app-link-ga-tracking',
  templateUrl: './app-link-ga-tracking.component.html',
  styleUrls: ['./app-link-ga-tracking.component.scss']
})
export class AppLinkGaTrackingComponent {

  @Input() label: string;
  @Input() redirectLink: string;
  @Input() toolTip?: string;
  @Input() imageSource?: any;
  @Input() linkType: string;
  @Input() isLinkDisabled?: boolean;
  @Input() serviceInstallationLink?: string;

  LINK_TYPE = LinkTypeEnum;

  constructor(private orderHistoryGaTrackingService: OrderHistoryGaTrackingService) { }

  gaTrackLinkClickEvent() {
    this.orderHistoryGaTrackingService.gaTrackingPDPLinkClickedEvent(this.label);
  }
}
